var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapInHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/map-pin-house"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.625 10C18.625 7.87827 17.7821 5.84344 16.2819 4.34315C14.7816 2.84285 12.7467 2 10.625 2C8.50327 2 6.46844 2.84285 4.96815 4.34315C3.46785 5.84344 2.625 7.87827 2.625 10C2.625 14.993 8.164 20.193 10.024 21.799C10.1974 21.929 10.4083 21.9992 10.625 21.999M18.625 22V19M15.625 22C15.3598 22 15.1054 21.8946 14.9179 21.7071C14.7304 21.5196 14.625 21.2652 14.625 21V17C14.625 16.8354 14.6656 16.6734 14.7432 16.5282C14.8208 16.3831 14.9331 16.2593 15.07 16.168L18.07 14.168C18.2343 14.0584 18.4275 13.9999 18.625 13.9999C18.8225 13.9999 19.0157 14.0584 19.18 14.168L22.18 16.168C22.3169 16.2593 22.4292 16.3831 22.5068 16.5282C22.5844 16.6734 22.625 16.8354 22.625 17V21C22.625 21.2652 22.5196 21.5196 22.3321 21.7071C22.1446 21.8946 21.8902 22 21.625 22H15.625ZM13.625 10C13.625 11.6569 12.2819 13 10.625 13C8.96815 13 7.625 11.6569 7.625 10C7.625 8.34315 8.96815 7 10.625 7C12.2819 7 13.625 8.34315 13.625 10Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapInHouse);
export default __webpack_public_path__ + "static/media/map_in_house.3e0c662c540dd7c51106205d4da8f458.svg";
export { ForwardRef as ReactComponent };